enum PaymentType {
  cheque = 'Cheque',
  usBank = 'US Bank',
  ETransfer = 'E-Transfer',
  eft = 'EFT',
}
export default PaymentType;
